import React, { useState } from "react";

interface InputLocationProps {
  label: string;
  placeholder?: string;
  error?: string;
  onChange?: (value: string) => void;
  value?: string;
  name?: string;
  className?: string;
}

export const InputLocation: React.FC<InputLocationProps> = ({
  label,
  placeholder,
  error,
  onChange,
  value,
  name,
  className = "",
}) => {
  const [loadingLocation, setLoadingLocation] = useState(false);

  const handleGetLocation = () => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser.");
      return;
    }

    setLoadingLocation(true);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        const locationString = `${latitude}, ${longitude}`;
        onChange?.(locationString); // Update the input value
        setLoadingLocation(false);
      },
      () => {
        alert("Unable to retrieve your location. Please try again.");
        setLoadingLocation(false);
      },
    );
  };

  return (
    <div className={`w-full ${className}`}>
      {/* Label */}
      <label
        htmlFor={name}
        className="block text-sm font-medium text-gray-700 mb-1 text-left"
      >
        {label}
      </label>

      {/* Input with embedded Button */}
      <div className="relative flex items-center">
        <input
          id={name}
          name={name}
          type="text"
          value={value}
          disabled={true}
          placeholder={placeholder}
          onChange={(e) => onChange?.(e.target.value)}
          className={`w-full border bg-white ${
            error ? "border-red-500" : "border-gray-500"
          } px-3 py-2 rounded shadow-sm focus:outline-none focus:ring-1 ${
            error ? "focus:ring-red-500" : "focus:ring-gray-500"
          }`}
        />

        {/* Button */}
        <button
          type="button"
          onClick={handleGetLocation}
          disabled={loadingLocation}
          className="absolute right-2 px-3 py-2 bg-perle-red text-white text-sm font-medium rounded focus:outline-none disabled:opacity-50"
        >
          {loadingLocation ? "Loading..." : "Get Location"}
        </button>
      </div>

      {/* Error Message */}
      {error && <p className="text-sm text-left text-red-500 mt-1">{error}</p>}
    </div>
  );
};
